import React from 'react';
import Routes from './Routes';
import FloatingDisclaimerButton from './components/ui/FloatingDisclaimerButton';

function App() {
  return (
    <>
      <Routes />
      <FloatingDisclaimerButton />
    </>
  );
}

export default App;